import { createContext, useContext } from 'react';

export interface OfflineRuntimeContextValue {
  enabled: boolean;
  isLoading: boolean;
  error: Error | null;
  features: Record<string, unknown>;
  refresh: () => void;
}

const EMPTY_FEATURES: Record<string, unknown> = Object.freeze({});

export const defaultOfflineRuntimeContext: OfflineRuntimeContextValue = {
  enabled: false,
  isLoading: false,
  error: null,
  features: EMPTY_FEATURES,
  refresh: () => undefined,
};

export const OfflineRuntimeContext =
  createContext<OfflineRuntimeContextValue>(defaultOfflineRuntimeContext);

export const useOfflineRuntimeContext = (): OfflineRuntimeContextValue =>
  useContext(OfflineRuntimeContext);

export const getEmptyOfflineRuntimeFeatures = (): Record<string, unknown> => EMPTY_FEATURES;
